import { Briefcase, Buildings, Calendar, ReceiptItem, UserSquare } from 'iconsax-react';

import type { EntityConfig, EntityType, GlobalSearchItem } from '@core/types/search';

const quoteConfig = {
  label: 'Quote',
  pluralLabel: 'Quotes',
  Icon: ReceiptItem,
  routePrefix: '/quotes',
  getName: (item: GlobalSearchItem): string => item.title,
  getStatus: (item: GlobalSearchItem): string | null =>
    (item.customData?.statusName as string) ?? null,
  getContext: (item: GlobalSearchItem): string | null =>
    (item.customData?.companyName as string) ?? null,
} satisfies EntityConfig<GlobalSearchItem>;

const projectConfig = {
  label: 'Project',
  pluralLabel: 'Projects',
  Icon: Briefcase,
  routePrefix: '/projects',
  getName: (item: GlobalSearchItem): string => item.title,
  getStatus: (item: GlobalSearchItem): string | null =>
    (item.customData?.statusName as string) ?? null,
  getContext: (): null => null,
} satisfies EntityConfig<GlobalSearchItem>;

const companyConfig = {
  label: 'Company',
  pluralLabel: 'Companies',
  Icon: Buildings,
  routePrefix: '/companies',
  getName: (item: GlobalSearchItem): string => item.title,
  getStatus: (): null => null,
  getContext: (): null => null,
} satisfies EntityConfig<GlobalSearchItem>;

const contactConfig = {
  label: 'Contact',
  pluralLabel: 'Contacts',
  Icon: UserSquare,
  routePrefix: '/contacts',
  getName: (item: GlobalSearchItem): string => item.title,
  getStatus: (): null => null,
  getContext: (item: GlobalSearchItem): string | null =>
    (item.customData?.companyName as string) ?? null,
} satisfies EntityConfig<GlobalSearchItem>;

const activityConfig = {
  label: 'Activity',
  pluralLabel: 'Activities',
  Icon: Calendar,
  routePrefix: '/activities',
  getName: (item: GlobalSearchItem): string => item.title,
  getStatus: (item: GlobalSearchItem): string | null => (item.customData?.status as string) ?? null,
  getContext: (): null => null,
} satisfies EntityConfig<GlobalSearchItem>;

export const ENTITY_CONFIGS: Record<EntityType, EntityConfig<GlobalSearchItem>> = {
  quotes: quoteConfig,
  projects: projectConfig,
  companies: companyConfig,
  contacts: contactConfig,
  activities: activityConfig,
};

export const ENTITY_TAB_ORDER: EntityType[] = [
  'quotes',
  'projects',
  'companies',
  'contacts',
  'activities',
];
